import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  datasets: [
    {
      label: 'Monthly Sales (%)',
      data: [40, 38, 6, 2, 10, 4], // numbers, not strings
      backgroundColor: [
        'rgba(255, 99, 132, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(255, 206, 86, 0.6)',
        'rgba(75, 192, 192, 0.6)',
        'rgba(153, 102, 255, 0.6)',
        'rgba(255, 159, 64, 0.6)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        color: '#ffffff',
      },
    },
    title: {
      display: true,
      text: 'Last 6 Month Sale',
      color: '#ffffff', // Title color white
    },
    tooltip: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.raw + '%'; // show percentage in tooltip
        },
      },
    },
  },
};

export function Circle() {
  return (
    <div className="w-[50%] h-[350px] p-4 bg-gray-700 rounded-lg">
      <Doughnut data={data} options={options} style={{ width: '100%', height: '100%' }} />
    </div>
  );
}
